import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import Illustration from '@repo/visual-assets/illustrations/ill-qf-cp-general-rejected.svg';
import styles from './styles.module.css';

export function FourthlineErrorsFraud(): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.wrapper} data-test-fourthline-error-fraud>
      <img
        alt=""
        className={styles.illustration}
        data-test-fourthline-error-fraud-illustration
        role="presentation"
        src={Illustration}
      />
      <h1 className="heading-section mb-16" data-test-fourthline-error-fraud-title>
        {formatMessage(
          {
            id: 'fourthline.errors.fraud.title',
          },
          { provider: 'Fourthline' }
        )}
      </h1>
      <p className="body-standard mb-32" data-test-fourthline-error-fraud-subtitle>
        {formatMessage({
          id: 'fourthline.errors.fraud.subtitle',
        })}
      </p>
    </div>
  );
}
